import React, { useCallback } from 'react';
import { View, StyleSheet } from 'react-native';
import TouchableBounce from 'utils/packages/TouchableBounce';
import { rem } from 'design-system';
import { useAppSelector } from 'store/hooks';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import FastImage from 'utils/packages/rnFastImage';
import { selectShowSecclFlow } from 'features/invest/reducers/selectors';
import OnboardingSquircle from '../../components/OnboardingSquircle';
const PROVIDERS = [
    [
        {
            symbol: 'NFLX',
            color: undefined,
            image: require('../icons/invest/netflix.png'),
        },
        {
            symbol: 'META',
            color: undefined,
            image: require('../icons/invest/meta.png'),
        },
    ],
    [
        {
            symbol: 'AMZN',
            color: undefined,
            image: require('../icons/invest/amazon.png'),
        },
        {
            symbol: 'TSLA',
            color: undefined,
            image: require('../icons/invest/tesla.png'),
        },
        {
            symbol: 'MA',
            color: undefined,
            image: require('../icons/invest/mastercard.png'),
        },
    ],
    [
        {
            symbol: 'MSFT',
            color: undefined,
            image: require('../icons/invest/microsoft.png'),
        },
        {
            symbol: 'AAPL',
            color: undefined,
            image: require('../icons/invest/apple.png'),
        },
    ],
];
const SECCL_PROVIDERS = [
    [
        {
            color: '#96151D',
            symbol: 'vanguard',
            image: require('../icons/invest/vanguardLogo.png'),
        },
        {
            color: '#000',
            symbol: 'blackrock',
            image: require('../icons/invest/blackrockLogo.png'),
        },
    ],
    [
        {
            color: '#6D933E',
            symbol: 'fidelity',
            image: require('../icons/invest/fidelity_logo.png'),
        },
        {
            color: '#FFFFFF',
            symbol: 'hsbc',
            image: require('../icons/invest/hsbc.png'),
        },
        {
            symbol: 'invesco',
            color: '#183988',
            image: require('../icons/invest/invescoLogo.png'),
        },
    ],
    [
        {
            symbol: 'lg',
            color: '#FFFFFF',
            image: require('../icons/invest/lg.png'),
        },
        {
            symbol: 'ishares',
            color: '#71CA32',
            image: require('../icons/invest/ishares.png'),
        },
    ],
];
const CarouselCardInvest = ({ small, medium, pressable, withShadow, }) => {
    const { width } = useAppFrameDimensions();
    const navigation = useMainStackNavigation();
    const showSecclFlow = useAppSelector(selectShowSecclFlow);
    const handlePress = useCallback((symbol) => () => {
        navigation.navigateDeprecated('InvestStock', { symbolOrAssetId: symbol });
    }, []);
    return (<View style={[styles.container, { maxWidth: width + rem(300) }]}>
      {(showSecclFlow ? SECCL_PROVIDERS : PROVIDERS).map((row, index) => (<View style={styles.row} key={String(index)}>
          {row.map(({ image, symbol, color }) => (<TouchableBounce key={symbol} onPress={handlePress(symbol)} disabled={showSecclFlow || !pressable}>
              <OnboardingSquircle rotate medium={medium ? !showSecclFlow : false} {...(small
                ? {
                    small: true,
                }
                : {})} color={color} withShadow={withShadow} style={styles.squircle}>
                <FastImage style={(showSecclFlow
                    ? styles.secclImage
                    : styles.image)} source={image}/>
              </OnboardingSquircle>
            </TouchableBounce>))}
        </View>))}
    </View>);
};
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
    },
    row: {
        flexDirection: 'row',
    },
    squircle: {
        marginHorizontal: rem(12),
    },
    image: {
        height: rem(32),
        width: rem(32),
    },
    secclImage: {
        width: '115%',
        height: '115%',
    },
});
export default CarouselCardInvest;
